import { add, remove, qs, qsa } from '@fluorescent/dom';

import { AnimateProductItem } from '@/lib/animation';

const selectors = {
  item: '.product-item',
  itemInner: '.product-item__inner',
  quickShopButton: '.product-item__quick-add-button',
  quickShopHeightTest: '.product-item__quick-add-button-text-height',
};

export default function ProductItem(container) {
  const items = qsa(selectors.item, container);
  if (!items.length) return;

  // Add z-index for quick-buy overlap
  items.forEach((item, i) =>
    item.style.setProperty('--z-index-item', items.length - i)
  );

  const productItemAnimations = AnimateProductItem(items);
  let resizeTimeout;

  // Update item height on window resize
  window.onresize = function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  };

  checkQuickBuyTextHeight();

  function handleResize() {
    checkQuickBuyTextHeight();
  }

  function checkQuickBuyTextHeight() {
    items.forEach(item => {
      const quickShopButtonText = qs(`${selectors.quickShopButton} span`, item);
      if (!quickShopButtonText) return;
      const testHeight = qs(
        selectors.quickShopHeightTest,
        quickShopButtonText.parentNode
      ).offsetHeight;
      const textHeight = quickShopButtonText.offsetHeight;

      if (textHeight > testHeight) {
        add(quickShopButtonText.parentNode.parentNode, 'show-icon');
      } else {
        remove(quickShopButtonText.parentNode.parentNode, 'show-icon');
      }
    });
  }

  const unload = () => {
    productItemAnimations.destroy();
  };

  return { unload };
}
